import React from "react";
import { Link, useLocation } from "react-router-dom";
import Auth from "../../../utils/AuthUtils";
import { getAccessRules } from "../../../constants/accessRules";
import { useTranslation } from "react-i18next";

function Sidebar() {
  const { t } = useTranslation();
  const currentPath = useLocation().pathname;

  const roleToDisplay = Auth.getUserDetails("roles");
  const image = Auth.getUserDetails("image");

  const access = getAccessRules(roleToDisplay);
  const allowedItems = access.sidebar;

  return (
    <div className="sidebar" id="sidebar">
      <div className="sidebar-inner slimscroll">
        <div id="sidebar-menu" className="sidebar-menu">
          <ul>
            <li className="clinicdropdown">
              <Link to="/admin/dashboard">
                <img
                  src={image || `${process.env.PUBLIC_URL}/img/user-dummy.jpg`}
                  className="img-fluid"
                  alt="Profile"
                />
                <div className="user-names">
                  <h5>{Auth.getUserDetails("name")}</h5>
                  <h6 style={{ fontSize: 12 }}>
                    {Auth.getUserDetails("roles")}
                  </h6>
                  {Auth.getUserDetails("state") && (
                    <h6 style={{ fontSize: 12 }}>
                      {Auth.getUserDetails("state") || ""} -{" "}
                      {Auth.getUserDetails("constituency") || ""}
                    </h6>
                  )}
                </div>
              </Link>
            </li>
          </ul>
          <ul>
            <li>
              <h6 className="submenu-hdr">{t('main_menu')}</h6>
              <ul>
                {allowedItems.includes("dashboard") && (
                  <li>
                    <Link
                      to="/admin/dashboard"
                      className={
                        currentPath === "/admin/dashboard" ? "active" : ""
                      }
                    >
                      <i className="ti ti-layout-2" />
                      <span>{t('dashboard')}</span>
                    </Link>
                  </li>
                )}
              </ul>
            </li>
            <li>
              <h6 className="submenu-hdr">{t('management')}</h6>
              <ul>
                {allowedItems.includes("mp") && (
                  <li>
                    <Link
                      to="/admin/mp"
                      className={currentPath === "/admin/mp" ? "active" : ""}
                    >
                      <i className="ti ti-users" />
                      <span>MP</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("members") && (
                  <li>
                    <Link
                      to="/admin/members"
                      className={
                        currentPath === "/admin/members" ? "active" : ""
                      }
                    >
                      <i className="ti ti-users" />
                      <span>{t('members')}</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("game-selection") && (
                  <li>
                    <Link
                      to="/admin/game-selection"
                      className={
                        currentPath === "/admin/game-selection" ? "active" : ""
                      }
                    >
                      <i className="ti ti-calendar" />
                      <span>{t('game_selection')}</span>
                    </Link>
                  </li>
                )}
                
                {allowedItems.includes("game-calendar") && (
                  <li>
                    <Link
                      to="/admin/game-calendar"
                      className={
                        currentPath === "/admin/game-calendar" ? "active" : ""
                      }
                    >
                      <i className="ti ti-calendar" />
                      <span>{t('game_calendar')}</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("media") && (
                  <li>
                    <Link
                      to="/admin/media"
                      className={currentPath === "/admin/media" ? "active" : ""}
                    >
                      <i className="ti ti-camera" />
                      <span>{t('upload_media')}</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("sports") && (
                  <li>
                    <Link
                      to="/admin/sports"
                      className={
                        currentPath === "/admin/sports" ? "active" : ""
                      }
                    >
                      <i className="ti ti-atom-2" />
                      <span>{t('sports')}</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("sop-guide-add") && (
                  <li>
                    <Link
                      to="/admin/sop-guide/list"
                      className={
                        currentPath === "/admin/sop-guide/list" ? "active" : ""
                      }
                    >
                      <i className="ti ti-atom-2" />
                      <span>{t('sop_guide')}</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("sop-guide") && (
                  <li>
                    <Link
                      to="/admin/sop-guide"
                      className={
                        currentPath === "/admin/sop-guide" ? "active" : ""
                      }
                    >
                      <i className="ti ti-timeline-event-exclamation" />
                      <span>SOP Guide</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("branding-kit") && (
                  <li>
                    <Link
                      to="/admin/branding-kit"
                      className={
                        currentPath === "/admin/branding-kit" ? "active" : ""
                      }
                    >
                      <i className="ti ti-icons" />
                      <span>Branding Kit</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("registrations") && (
                  <li>
                    <Link
                      to="/admin/registrations"
                      className={
                        currentPath === "/admin/registrations" ? "active" : ""
                      }
                    >
                      <i className="ti ti-user-up" />
                      <span>{t('registered_participants')}</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("analytics") && (
                  <li>
                    <Link
                      to="/admin/analytics"
                      className={
                        currentPath === "/admin/analytics" ? "active" : ""
                      }
                    >
                      <i className="ti ti-brand-airtable" />
                      <span>{t('analytics')}</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("settings") && (
                  <li>
                    <Link
                      to="/admin/settings"
                      className={
                        currentPath === "/admin/settings" ? "active" : ""
                      }
                    >
                      <i className="ti ti-report-analytics" />
                      <span>{t('settings')}</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("help-centre") && (
                  <li>
                    <Link
                      to="/admin/help-centre"
                      className={
                        currentPath === "/admin/help-centre" ? "active" : ""
                      }
                    >
                      <i className="ti ti-report-analytics" />
                      <span>{t('help_centre')}</span>
                    </Link>
                  </li>
                )}

                {allowedItems.includes("user-guide") && (
                  <li>
                    <Link
                      to="/admin/user-guide"
                      className={
                        currentPath === "/admin/user-guide" ? "active" : ""
                      }
                    >
                      <i className="ti ti-report-analytics" />
                      <span>{t('user_guide')}</span>
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;